import { useState } from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { useAppContext } from '@/common/hooks/AppStateProvider';
import ExpenseExclusionDrawer from './ExpenseExclusionDrawer';

const ExpenseExclusionManager = ({ organizationId }) => {
  const [open, setOpen] = useState(false);
  const { session } = useAppContext();
  if (!['owner', 'admin'].includes(session.role)) return null;
  return (
    <>
      <Button onClick={() => setOpen(true)}>费用排除规则</Button>
      {open && (
        <ExpenseExclusionDrawer organizationId={organizationId} onClose={() => setOpen(false)} />
      )}
    </>
  );
};
ExpenseExclusionManager.propTypes = { organizationId: PropTypes.string.isRequired };
export default ExpenseExclusionManager;
